export const routes={

  //Authentication
  home: '/home',
  about: '/about',
  contact: '/contact',
  services: '/services',
  product: '/products',

  //Authentication
  signIn3: '/signin-3',
  signIn2: '/signin-2',
  signIn: '/login',
  signUp: '/signup',
  register3: '/register-3',
  register2: '/register-2',
  register: '/register',
  forgotPassword: '/forgot-password-3',
  forgotPassword2: '/forgot-password-2',
  forgotPassword3: '/forgot-password',
  resetPassword3: '/reset-password-3',
  resetPassword2: '/reset-password-2',
  resetPassword: '/reset-password',
  twoStepVerification3: '/two-step-verification-3',
  twoStepVerification2: '/two-step-verification-2',
  twoStepVerification: '/two-step-verification',
  emailVerification3: '/email-verification-3',
  emailVerification2: '/email-verification-2',
  emailVerification: '/email-verification',
  success3: '/success-3',
  success2: '/success-2',
  success: '/success',
  lockScreen: '/lock-screen',

  Horizontal: '/layouts/layout-horizontal',
  Detached: '/layouts/layout-detached',
  Modern: '/layouts/layout-modern',
  TwoColumn: '/layouts/layout-two-column',
  hovered: '/layouts/layout-hovered',
  Boxed: '/layouts/layout-boxed',
  RTL: '/layouts/layout-rtl',
  Dark: '/layouts/layout-dark',

  //FEATURES//

  //dashboard
  index:'/dashboard/index',
  adminDashboard:'/dashboard/admin-dashboard',
  salesDashboard: '/dashboard/sales-dashboard',
  //superadmin
  superadminDashboard: '/super-admin/dashboard',
  superadminCompanies: '/super-admin/companies',
  superadminSubscriptions: '/super-admin/subscriptions',
  superadminPackages: '/super-admin/packages',
  superadminDomain: '/super-admin/domain',
  purchaseTransaction: '/super-admin/purchase-transaction',
  //application
  audioCall: '/application/audio-call',
  videoCall: '/application/video-call',
  callHistory: '/application/call-history',
  toDo: '/application/todo',
  toDoList: '/application/todo-list',
  socialFeed: '/application/social-feed',
  searchList: '/application/search-list',
  kanban: '/application/projects',
  notes: '/application/notes',
  ecommerce: '/application/ecommerce',
   products: '/application/ecommerce/products',
  orders: '/application/ecommerce/orders',
  wishlist: '/application/ecommerce/wishlist',
  ecommerceCustomers: '/application/ecommerce/customers',
  cart: '/application/ecommerce/cart',
  checkout: '/application/ecommerce/checkout',
  reviews: '/application/ecommerce/reviews',
  fileShared: '/application/file-shared',
  chat: '/application/chat',
  calendar: '/application/calendar',
  contacts: '/application/contacts',
  email: '/application/email',
  emailReply: '/application/email-reply',
  fileManager: '/application/file-manager',
  fileArchived: '/application/file-archived',
  fileDocument: '/application/file-document',
  fileFavorites: '/application/file-favourites',
  fileManagerDeleted: '/application/file-manager-deleted',
  fileRecent: '/application/file-recent',
  //inventory
  productList: '/inventory/product/product-list',
  addProduct: '/inventory/product/add-product',
  expiredProduct: '/inventory/product/expired-products',
  editProduct: '/inventory/product/edit-product',
  productDetails: '/inventory/product/product-details',
  categoryList: '/inventory/category/category-list',
  subCategories: '/inventory/category/sub-categories',
  brandList: '/inventory/brand-list',
  lowStock: '/inventory/stock/low-stocks',
  units: '/inventory/units',
  varriantAttributes: '/inventory/varriant-attributes',
  qrCode: '/inventory/qrcode',
  warranty: '/inventory/warranty',
  barCode:  '/inventory/barcode',

  //stocks
  manageStocks: '/stock/manage-stocks',
  stockAdjustment: '/stock/stock-adjustment',
  stockTransfer: '/stock/stock-transfer',
  //sales
  salesList: '/sales/online-order',
  posOrder: '/sales/pos-order',
  onlineOrders: '/sales/online-orders',
  invoice: '/sales/invoice',
  invoiceDetails: '/sales/invoice-details',
  pos: '/sales/pos',
  pos2: '/sales/pos-2',
  pos3: '/sales/pos-3',
  pos4: '/sales/pos-4',
  pos5: '/sales/pos-5',
  salesReturn: '/sales/sales-return',
  quotationList: '/sales/quotation-list',
  salesReturnLists: '/sales/sales-return-lists',
  createSalesReturns: '/sales/create-sales-returns',
  addSales: '/sales/add-sales',
  editSalesReturns: '/sales/edit-sales-returns',
  editSales: '/sales/edit-sales',
  salesDetails: '/sales/sales-details',
  //promo
  coupons: '/promo/coupons',
  giftCards: '/promo/gift-cards',
  discount: '/promo/discount',
  discountPlan: '/promo/discount-plan',
  //purchase
  purchaseOrderReport: '/purchase/purchase-order-report',
  purchaseList: '/purchase/purchase-list',
  addPurchase: '/purchase/add-purchase',
  importPurchase: '/purchase/import-purchase',
  editPurchase: '/purchase/edit-purchase',
  purchaseReturns: '/purchase/purchase-returns',

  //finance
  expenseList: '/expense/expense-list',
  expenseCategory: '/expense/expense-category',
  createExpense: '/expense/create-expense',
  editExpense: '/expense/edit-expense',
  income: '/finance/income',
  incomeCategory: '/finance/income-category',
  accountList: '/finance/account-list',
  moneyTransfer: '/finance/money-transfer',
  balanceSheet: '/finance/balance-sheet',
  trailBalance: '/finance/trial-balance',
  cashFlow: '/finance/cash-flow',
  accountStatement: '/finance/account-statement',
  //people
  customerList: '/people/customer-list',
  addCustomer: '/people/add-customer',
  suppliers: '/people/suppliers-list',
  addSupplier: '/people/add-supplier',
  userList: '/people/user-list',
  addUser: '/people/add-user',
  storeList: '/people/store-list',
  addStore: '/people/add-store',
  editCustomer: '/people/edit-customer',
  editSupplier: '/people/edit-supplier',
  editUser: '/people/edit-user',
  editStore: '/people/edit-store',
   customers: '/people/customers',
  billers: '/people/billers',
  wareHouse: '/people/warehouse',
  //hrm
  addEmployee: '/hrm/employee/add-employee',
  employeeDetails: '/hrm/employee/employee-details',
  editEmployee: '/hrm/employee/edit-employee',
  employeesList: '/hrm/employee/employee-list',
  employeesGrid: '/hrm/employee/employee-grid',
  designation: '/hrm/designation',
  department: '/hrm/department',
  departmentList: '/hrm/department/department-list',
  departmentGrid:'/hrm/department/department-grid',

  attendance: '/hrm/attendance',
  attendanceAdmin: '/hrm/attendance/attendance-admin',
  attendanceEmployee: '/hrm/attendance/attendance-employee',
  holidays: '/hrm/holidays',
  shift: '/hrm/shift',
  leavesAdmin: '/hrm/leaves/leaves-admin',
  leavesEmployee: '/hrm/leaves/leaves-employee',
  leavesType: '/hrm/leaves/leaves-type',
  payrollList: '/hrm/payroll/payroll-list',
  paySlip: '/hrm/payroll/payslip',
  //reports
   customerReport: '/reports/customer-report',
  customerDueReport: '/reports/customer-due-report',
  expenseReport: '/reports/expense-report',
  incomeReport: '/reports/income-report',
  inventoryReport: '/reports/inventory-report',
  stockHistory: '/reports/stock-history',
  soldStock: '/reports/sold-stock',
  invoiceReport: '/reports/invoice-report',
  profitAndLoss: '/reports/profit-and-loss',
  purchaseReport: '/reports/purchase-report',
  salesReport: '/reports/sales-report',
  bestSeller: '/reports/best-seller',
  supplierReport: '/reports/supplier-report',
  supplierDueReport: '/reports/supplier-due-report',
  taxReport: '/reports/tax-report',
  salesTax: '/reports/sales-tax',
  annualReport: '/reports/annual-report',
  productReport: '/reports/product-report',
  productExpiryReport: '/reports/product-expiry-report',
  productQuantityAlert: '/reports/product-quantity-alert',
  //content
  content: '/content',
  page: '/content/pages',
  blogs: '/content/blogs',
  location: '/content/location',
  countries: '/content/location/countries',
  cities: '/content/location/cities',
  states: '/content/location/states',
  testimonial: '/content/testimonial',
  faq: '/content/faq',
  allBlog: '/content/blogs/all-blog',
  blogDetails: '/content/blogs/blog-details',
  blogTag: '/content/blogs/blog-tag',
  categories: '/content/blogs/categories',
  blogComments: '/content/blogs/blog-comments',
  //user management
  deleteAccount: '/user-management/delete-account',
  rolesPermission: '/user-management/roles-permissions',
  permissions: '/user-management/permissions',
  users: '/user-management/users',
  //pages
  blankPage: '/pages/blank-page',
  pricing: '/pages/pricing',
  profile: '/pages/profile',
  activities: '/pages/activities',
  underMaintanance: '/pages/under-maintenance',
  //settings
  generalSettings: '/settings/general-settings/profile',
  paymentSettings: '/settings/payment-settings',
  currencySettings: '/settings/financial-settings/currency-settings',
  groupSettings: '/settings/group-permissions',
  createPermission: '/settings/create-permission',
  editPermission: '/settings/edit-permission',
  banIpAddress: '/settings/other-settings/ban-ip-address',
  connectedapp: '/settings/general-settings/connected-app',
  bankSettingsList: '/settings/financial-settings/bank-settings-list',
  bankSettingsGrid: '/settings/financial-settings/bank-settings-grid',
  languageSettings: '/settings/website-settings/language-settings',
  languageSettingsweb: '/settings/website-settings/language-settings-web',
  securitySettings: '/settings/general-settings/security-settings',
  settingsNotification: '/settings/general-settings/notification',
  connectedApps: '/settings/general-settings/connected-apps',
  systemSettings: '/settings/website-settings/system-settings',
  companySettings: '/settings/website-settings/company-settings',
  localizationSettings: '/settings/website-settings/localization-settings',
  prefixes: '/settings/website-settings/prefixes',
  appearance: '/settings/website-settings/appearance',
  socialAuthentication: '/settings/website-settings/social-authentication',
  preference: '/settings/website-settings/preference',
  invoiceSettings: '/settings/app-settings/invoice-settings',
  invoiceTemplate: '/settings/app-settings/invoice-template',
  printerSettings: '/settings/app-settings/printer-settings',
  posSettings: '/settings/app-settings/pos-settings',
  signatures: '/settings/app-settings/signatures',
  customFields: '/settings/app-settings/custom-fields',
  emailSettings: '/settings/system-settings/email-settings',
  emailTemplates: '/settings/system-settings/email-templates',
  smsGateway: '/settings/system-settings/sms-gateway',
  smsTemplates: '/settings/system-settings/sms-templates',
  otpSettings: '/settings/system-settings/otp-settings',
  gdprSettings: '/settings/system-settings/gdpr-settings',
  paymentGatewaySettings: '/settings/financial-settings/payment-gateway-settings',
  taxRates: '/settings/financial-settings/tax-rates',
  storageSettings: '/settings/other-settings/storage-settings',

  //UI Interface
  baseUi: '/base-ui',
  avatar: '/base-ui/ui-avatar',
  cards: '/base-ui/ui-cards',
  buttons: '/base-ui/ui-buttons',
  accordion: '/base-ui/ui-accordion',
  uiAlerts: '/base-ui/ui-alerts',
  uiPopovers: '/base-ui/ui-popovers',
  uiPlaceholders: '/base-ui/ui-placeholders',
  uiBadges: '/base-ui/ui-badges',
  uiBreadcrumb: '/base-ui/ui-breadcrumb',
  uiButtons: '/base-ui/ui-buttons',
  uiButtonsGroup: '/base-ui/ui-buttons-group',
  uiCards: '/base-ui/ui-cards',
  uiCarousel: '/base-ui/ui-carousel',
  uiCounter: '/base-ui/ui-counter',
  uiDropdowns: '/base-ui/ui-dropdowns',
  uiGrid: '/base-ui/ui-grid',
  uiImages: '/base-ui/ui-images',
  uiLightbox: '/base-ui/ui-lightbox',
  uiMedia: '/base-ui/ui-media',
  uiModals: '/base-ui/ui-modals',
  uiNavTabs: '/base-ui/ui-nav-tabs',
  uiOffcanvas: '/base-ui/ui-offcanvas',
  uiPagination: '/base-ui/ui-pagination',
  uiProgress: '/base-ui/ui-progress',
  uiRangeSlider: '/base-ui/ui-rangeslider',
  uiSpinner: '/base-ui/ui-spinner',
  uiSweetAlerts: '/base-ui/ui-sweetalerts',
  uiToasts: '/base-ui/ui-toasts',
  uiTooltips: '/base-ui/ui-tooltips',
  uiTypography: '/base-ui/ui-typography',
  uiVideo: '/base-ui/ui-video',
  uiAccordion: '/base-ui/ui-accordion',       // Duplicate; you may want to clean this
  uiAvatar: '/base-ui/ui-avatar',             // Duplicate
  uiBorders: '/base-ui/ui-borders',
  uiColors: '/base-ui/ui-colors',
  uiSortable: '/base-ui/ui-sortable',

  counter: '/advanced-ui/ui-counter',
  clipboard: '/advanced-ui/ui-clipboard',
  ribbon: '/advanced-ui/ui-ribbon',
  rating: '/advanced-ui/ui-rating',
  textEditor: '/advanced-ui/ui-text-editor',
  scrollbar: '/advanced-ui/ui-scrollbar',
  timeline: '/advanced-ui/ui-timeline',
  dragDrop: '/advanced-ui/ui-drag-drop',

  iconFontAwesome: '/icons/icon-fontawesome',
  iconFeather: '/icons/icon-feather',
  iconIonic: '/icons/icon-ionic',
  iconMaterial: '/icons/icon-material',
  iconPe7: '/icons/icon-pe7',
  iconSimpleline: '/icons/icon-simpleline',
  iconWeather: '/icons/icon-weather',
  iconThemify: '/icons/icon-themify',
  iconTypicon: '/icons/icon-typicon',
  iconFlag: '/icons/icon-flag',
  tabler: '/icons/icon-tabler',
  remix: '/icons/icon-remix',
  bootstrap: '/icons/icon-bootstrap',

  formWizard: '/forms/form-wizard',
  formPickers: '/forms/form-pickers',
  formBasicInputs: '/forms/form-basic-inputs',
  formInputsGroups: '/forms/form-input-groups',
  formHorizontal: '/forms/form-horizontal',
  formVertical: '/forms/form-vertical',
  formMask: '/forms/form-mask',
  formValidation: '/forms/form-validation',
  formSelect: '/forms/form-select',
  matSelect: '/forms/mat-select',
  formFileUpload: '/forms/form-fileupload',
  formCheckboxRadios: '/forms/form-checkbox-radios',
  formElements: '/forms/form-elements',
  formGridGutters: '/forms/form-grid-gutters',
  formFloatingLabels: '/forms/form-floating-labels',

  chartApex: '/charts/chart-apex',
  chartPrime: '/charts/prime-ng',

   basicTable: '/table/tables-basic',
  dataTable: '/table/data-basic',
  leaflet:'/maps/leaflets',

  //error
  error404: '/error/error-404',
  error500: '/error/error-500',
  comingSoon: '/pages/coming-soon',


}
